module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black-back"
  }, [(_vm.pageloading) ? _c('div', {
    staticStyle: {
      "z-index": "1000",
      "background": "#000",
      "opacity": "0.5",
      "position": "fixed",
      "top": "0",
      "bottom": "0",
      "right": "0",
      "left": "0"
    }
  }, [_c('van-loading', {
    staticStyle: {
      "margin-top": "100px",
      "z-index": "1001"
    },
    attrs: {
      "size": "24px",
      "color": "#fff",
      "vertical": ""
    }
  }, [_vm._v("加载中...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-title"
  }, [_vm._v(_vm._s(_vm.row.saiqu_name) + " " + _vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.row.subject.subject_name))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.row.subject.mingcheng))])]), _vm._v(" "), _c('div', {
    staticClass: "score-content",
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [(_vm.row.subject.video && !_vm.pageloading) ? _c('video', {
    attrs: {
      "width": "100%",
      "height": "180px",
      "src": _vm.row.subject.video,
      "controls": ""
    }
  }) : _c('van-notice-bar', {
    staticStyle: {
      "z-index": "10000",
      "width": "100%"
    },
    attrs: {
      "text": "视频未上传"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "score-content"
  }, [_c('div', {
    staticClass: "score-content-left",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "score-value-box"
  }, [_c('div', {
    staticClass: "score-value-text flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v(_vm._s('裁判长' + '-' + _vm.row.caipan.name) + " 最终得分")])]), _vm._v(" "), (_vm.row.subject.video) ? _c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.subject.video),
      expression: "row.subject.video",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "flex-start",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "edit"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("复制网址")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-start",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "replay"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("刷新")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-content flex-center"
  }, [_vm._v(_vm._s(_vm.formData.score > 0 ? _vm.formData.score : '--') + "\n"), (_vm.scoreStatus == 'pen') ? _c('van-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#0dac0d"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scoreStatus == 'add') ? _c('van-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "name": "play",
      "color": "#ff0000"
    }
  }) : _vm._e()], 1), _vm._v(" "), (false) ? _c('div', {
    staticClass: "score-comment-box"
  }, [_c('div', {
    staticClass: "score-comment-head flex-between"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "score-comment-head-right",
    on: {
      "click": _vm.onComment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/comment-edit.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "score-comment-text"
  }, _vm._l((_vm.commentResult), function(cvalue, cindex) {
    return _c('van-tag', {
      key: cindex,
      staticStyle: {
        "margin": "0 10px 10px 0"
      },
      attrs: {
        "closeable": ""
      },
      on: {
        "click": function($event) {
          return _vm.commentClose(cindex)
        },
        "close": function($event) {
          return _vm.commentClose(cindex)
        }
      }
    }, [_vm._v(_vm._s(cvalue.name))])
  }), 1)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "score-caipan-box score-caipan-online"
  }, [_c('div', {
    staticClass: "score-caipan-value flex-between"
  }, [_c('div', {
    staticClass: "score-caipan-left flex-start"
  }, [_c('div', {
    staticClass: "caipan-button",
    staticStyle: {
      "padding": "5px 10px 5px 0"
    },
    on: {
      "click": _vm.toLoginOutAuto
    }
  }, [_vm._v("退出")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-name"
  }, [_vm._v(" " + _vm._s(_vm.row.caipan.jgroup == 1 ? 'B组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name :
    'A组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-right"
  }, [_vm._v("网络正常")])])]) : _vm._e()])]), _vm._v(" "), _c('van-cell-group', {
    staticStyle: {
      "margin": "0 !important"
    }
  }, [_c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "裁判1",
      "value": _vm.row.subject.score1,
      "label": _vm.cpmap['index1'] ? _vm.cpmap['index1'].name + ' ' + _vm.cpmap['index1'].phone : '暂未配置'
    },
    on: {
      "click": function($event) {
        return _vm.cpselect(1)
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "裁判2",
      "value": _vm.row.subject.score2,
      "label": _vm.cpmap['index2'] ? _vm.cpmap['index2'].name + ' ' + _vm.cpmap['index2'].phone : '暂未配置'
    },
    on: {
      "click": function($event) {
        return _vm.cpselect(2)
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "裁判3",
      "value": _vm.row.subject.score3,
      "label": _vm.cpmap['index3'] ? _vm.cpmap['index3'].name + ' ' + _vm.cpmap['index3'].phone : '暂未配置'
    },
    on: {
      "click": function($event) {
        return _vm.cpselect(3)
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "裁判4",
      "value": _vm.row.subject.score4,
      "label": _vm.cpmap['index4'] ? _vm.cpmap['index4'].name + ' ' + _vm.cpmap['index4'].phone : '暂未配置'
    },
    on: {
      "click": function($event) {
        return _vm.cpselect(4)
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "加分",
      "value": _vm.row.subject.score_add
    },
    on: {
      "click": function($event) {
        return _vm.cpselect('_add')
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "center": "",
      "is-link": "",
      "title": "减分",
      "value": _vm.row.subject.score_pen
    },
    on: {
      "click": function($event) {
        return _vm.cpselect('_pen')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0 0 10px 0"
    }
  }, [(_vm.row.subject.status == 1) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "#FF4D50",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认最终分数")]) : _vm._e(), _vm._v(" "), (_vm.row.subject.status == 2) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "#0EB791",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.subject.status == 2) ? _c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.restart
    }
  }, [_vm._v("修改分数")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goPre()
      }
    }
  }, [_vm._v("上一队")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.showList()
      }
    }
  }, [_vm._v("全部队伍" + _vm._s(_vm.current_index + 1) + "/" + _vm._s(_vm.list.length))]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v("下一队")])], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "title": "操作"
    },
    model: {
      value: (_vm.actionshow),
      callback: function($$v) {
        _vm.actionshow = $$v
      },
      expression: "actionshow"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "修改分数",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        _vm.keyShow = true
      }
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "拨打电话",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.makephone()
      }
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('div', [_vm._v("that.formData: || " + _vm._s(_vm.formData))]), _vm._v(" "), _c('div', [_vm._v("row.caipan: || " + _vm._s(_vm.row.caipan))]), _vm._v(" "), _c('div', [_vm._v("row.subject: || " + _vm._s(_vm.row.subject))]), _vm._v(" "), _c('div', [_vm._v("scoreStatus: || " + _vm._s(_vm.scoreStatus))]), _vm._v(" "), _c('div', [_vm._v("dataAll: || " + _vm._s(_vm.dataAll))])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.peopleShow),
      callback: function($$v) {
        _vm.peopleShow = $$v
      },
      expression: "peopleShow"
    }
  }, [_c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "people-title"
  }, [_vm._v("运动员")]), _vm._v(" "), _c('div', {
    staticClass: "people-content"
  }, [_vm._v(_vm._s(_vm.row.subject.yundongyuans))])])]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "90%",
      "height": "80%"
    },
    model: {
      value: (_vm.listShow),
      callback: function($$v) {
        _vm.listShow = $$v
      },
      expression: "listShow"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "overflow": "-y scroll"
    }
  }, [_c('van-cell-group', _vm._l((_vm.list), function(item, iindex) {
    return _c('van-cell', {
      key: item.id,
      attrs: {
        "icon": iindex == _vm.current_index ? 'success' : '',
        "center": "",
        "is-link": "",
        "label": item.mingcheng
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(item, iindex)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "flex-align"
    }, [(item.status == 2) ? _c('span', {
      staticClass: "font-size3 bold ok"
    }, [_vm._v(_vm._s(iindex + 1) + "# " + _vm._s(item.subject_name))]) : (item.score1 > 0 || item.score2 > 0 || item.score3 > 0 || item.score4 > 0) ? _c('span', {
      staticClass: "font-size3 bold doing"
    }, [_vm._v(_vm._s(iindex + 1) + "# " + _vm._s(item.subject_name))]) : _c('span', {
      staticClass: "font-size3 "
    }, [_vm._v(_vm._s(iindex + 1) + "# " + _vm._s(item.subject_name))])])])], 2)
  }), 1)], 1)]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    model: {
      value: (_vm.keyShow),
      callback: function($$v) {
        _vm.keyShow = $$v
      },
      expression: "keyShow"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "50px",
      "text-align": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.actionscore))]), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.keyShow,
      "theme": "custom",
      "extra-key": ".",
      "close-button-text": "确认"
    },
    on: {
      "close": _vm.onKeyOk,
      "blur": function($event) {
        _vm.show = false
      }
    },
    model: {
      value: (_vm.actionscore),
      callback: function($$v) {
        _vm.actionscore = $$v
      },
      expression: "actionscore"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo"
  }, [_c('div', {
    staticClass: "score-logo-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-comment-head-left flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("评语")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7206f0fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ShequScoreCheck.vue
// module id = 2474
// module chunks = 0